import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";

export const useAgendaStore = defineStore("parent/agenda", {
  state: () => {
    return {
      agenda: [],
      error: null,
      loading: true,
      showConfirmationModal: false,
      pendingConfirmation: false
    };
  },
  getters: {
    getMeetingIndexById: (state) => {
      return (pta_id) => state.agenda.findIndex((meeting) => meeting.pta_id === pta_id);
    },
    getById: (state) => {
      return (ptaId) => state.agenda.find((meeting) => meeting.pta_id === ptaId);
    }
  },
  actions: {
    async requestTranslator(conferenceId, language) {
      // language: string | null
      return FetchService.fetchData(`/meetingdetail/request-translator/${conferenceId}`, "post", {
        language: language ?? null
      });
    },
    async deleteComment(details) {
      this.loading = true;
      const resp = await FetchService.fetchData(
        "/meetingdetail/" + details.pta_id,
        "delete",
        details
      );
      this.loading = false;
      return resp;
    },
    async saveDetails(details) {
      this.loading = true;
      const resp = await FetchService.fetchData("/meetingdetail/" + details.pta_id, "put", details);
      this.loading = false;
      return resp;
    },
    async fetchAgenda() {
      this.loading = true;
      await FetchService.fetchData("/schedule", "get").then((agenda) => {
        this.loading = false;
        agenda.forEach((appointment) => {
          if (!appointment.meeting_types) {
            appointment.meeting_types = {
              in_person: !!appointment.room,
              virtual:
                !!appointment.virtual_room ||
                !!appointment.zoom_link ||
                !!appointment.google_meet_url,
              phone: false,
              callback: false,
              virtual_type: appointment.virtual_room
                ? "url"
                : appointment.zoom_link
                  ? "zoom"
                  : appointment.google_meet_url
                    ? "google"
                    : "url"
            };
          } else if (typeof appointment.meeting_types === "string") {
            appointment.meeting_types = JSON.parse(appointment.meeting_types);
          }
        });

        this.agenda = agenda;
        this.conference_agenda = {};
        this.teachers_booked = [];
      });
    },
    async reserveMeeting(
      appointmentType,
      childrenUid,
      uid,
      conferenceId,
      conferenceDayUid,
      timeslot
    ) {
      const appointment = {
        children_uid: childrenUid,
        teacher_uid: appointmentType == "teacher" ? uid : null,
        team_uid: appointmentType == "team" ? uid : null,
        timeslot: timeslot.format("YYYY-MM-DD HH:mm:ss"),
        conference_id: conferenceId,
        conference_days_id: conferenceDayUid
      };
      const jsonBody = { appointment: appointment };
      const resp = await FetchService.fetchData("/schedule", "post", jsonBody);
      // resp.then(response=>{console.log("writing response");console.log(response);});
      return resp;
    },
    async cancelMeeting(ptaId) {
      return FetchService.fetchData("/schedule/" + ptaId, "delete");
    },
    async getEmail(conferenceId) {
      let url = "/schedule/email";
      if (conferenceId) {
        url += "?conference_id=" + conferenceId;
      }
      const resp = FetchService.fetchData(url, "get");
      return resp;
    },
    async exportCalendar() {
      const resp = FetchService.fetchData("/schedule/export", "get");
      return resp;
    }
  }
});
